import {Component, EventEmitter, OnInit, ViewChild} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import {MDBModalRef, ModalDirective} from 'ng-uikit-pro-standard';
import { filter, flatMap } from 'rxjs/operators';
import { TemplateCheckpoint } from '../../../../common/model/template-checkpoint';
import { ChecklistsService } from '../../../../common/services/checklists.service';
import { CheckPointValueType, IssueCategoryType } from '../../../../../modules/common/enums/enums';
import { Localization } from '../../../../../modules/common/enums/localization';
import { IdAndLabel } from '../../../../../modules/common/model/id-and-label';
import { ChecklistNode } from '../../checklist/model/checklist-node';
import { InspectionCheckpoint } from '../../../inspections/inspection/checkpoints/model/checkpoint';
import { ChecklistNodeCheckpoint, Checkpoint } from '../../checklist/model/checklist-node-checkpoint';

@Component({
  selector: 'app-add-update-checkpoint-modal',
  templateUrl: './add-update-checkpoint-modal.component.html',
  styleUrls: ['./add-update-checkpoint-modal.component.scss']
})
export class AddUpdateCheckpointModalComponent implements OnInit {

  public readonly Localization = Localization;
  public formGroup: UntypedFormGroup;
  public isCreatingInProgress: boolean = false;
  public valueTypes: IdAndLabel[] = [];
  public categories: IdAndLabel[] = [];
  public templateChecklistNodeId: number;
  public checkPoint: Checkpoint;
  constructor(
      private readonly translate: TranslateService,
      private readonly checklistsService: ChecklistsService,
      private readonly self: MDBModalRef,
  ) { }

  public get labelTypeControl(): UntypedFormControl { return this.formGroup.get('label') as UntypedFormControl; }
  public get valueTypeControl(): UntypedFormControl { return this.formGroup.get('valueType') as UntypedFormControl; }
  public get categoryTypeControl(): UntypedFormControl { return this.formGroup.get('categoryType') as UntypedFormControl; }


  private readonly onSave = new EventEmitter<Checkpoint>();

  ngOnInit(): void {
  }


  public show(templateChecklistNodeId: number, checkPoint?: Checkpoint){
    this.checkPoint = checkPoint ? checkPoint : null;
    this.templateChecklistNodeId = templateChecklistNodeId;
    this.loadData();
    this.initForm();
    return this.onSave.toPromise();
  }

  private initForm(){
    this.formGroup = new UntypedFormGroup({
      'label': new UntypedFormControl(this.checkPoint ? this.checkPoint.label : '', [Validators.required]),
      'valueType': new UntypedFormControl(this.checkPoint ? this.checkPoint.valueType : null, [Validators.required]),
      'categoryType': new UntypedFormControl(this.checkPoint ? this.checkPoint.categoryType : null, [Validators.required]),
    });
  }

  public close(){
    this.formGroup.reset();
    this.onSave.emit(null);
    this.self.hide();
  }

  public onSubmit(){
    if (this.formGroup.invalid) {
      Object.values(this.formGroup.controls)
        .forEach(c => c.markAsTouched());
    } else {
      this.checkPoint ? this.updateCheckpoint() : this.createCustomCheckpoint();
      this.onSave.emit(this.checkPoint);
    }
  }

  private updateCheckpoint(){
    this.isCreatingInProgress = true;
    this.checkPoint.label = this.labelTypeControl.value;
    this.checkPoint.valueType = this.valueTypeControl.value;
    this.checkPoint.categoryType = this.categoryTypeControl.value;
    this.checkPoint.reference = this.labelTypeControl.value;
    this.checklistsService.updateCheckpoint(this.checkPoint).subscribe({
      complete: () => {
        this.isCreatingInProgress = false;
        this.close();
      }
    })
  }

  private loadData(){
    this.valueTypes = this.getCheckpointValueTypes();
    this.categories = this.getKindOfProblems();
  }

  
  private getCheckpointValueTypes(){
    return Object.keys(CheckPointValueType).map(type => new IdAndLabel(CheckPointValueType[type], this.translate.instant(`checkPointValueType_${CheckPointValueType[type]}`)));
  }

  private getKindOfProblems() {
    return Object.keys(IssueCategoryType).map(category => new IdAndLabel(IssueCategoryType[category],
      this.translate.instant(`issueCategoryType_${IssueCategoryType[category]}`)));
  }

  private createCustomCheckpoint() {
    this.isCreatingInProgress = true;
    const newCustomCheckpoint: TemplateCheckpoint = {
      ...this.formGroup.value,
      reference: this.labelTypeControl.value,
    };

    this.checklistsService.addNewCheckpoint(newCustomCheckpoint)
      .pipe(
        filter(templateCheckpoint => templateCheckpoint.id !== undefined),
        flatMap(templateCheckpoint => this.checklistsService.addCheckpoint(this.templateChecklistNodeId, templateCheckpoint.id))
      )
      .subscribe({
        complete: () => {
          this.isCreatingInProgress = false;
          this.close();
        }
      });
  }
}
